import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getFolders(userId, pageKey) {
        try{            
            const response = await axios.get(`HR201/folders/${userId}`,
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api getFolders error')
            throw error
        }
    },
    async getFolderFileCount(folderId, pageKey) {
        try{            
            const response = await axios.get(`HR201/${folderId}/file-count`,
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api getFolderFileCount error')
            throw error
        }
    },
    async deleteFolder(folderId) {
        try{            
            const response = await axios.post(`HR201/${folderId}/delete`,
            {
                folder: {
                    folderId: folderId
                }
            },
            {
                headers: {
                    'page_key': pageKeys.hr201
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api deleteFolder error')
            throw error
        }
    },
    async getDocumentTypes(pageKey) {
        try{            
            const response = await axios.get(`HR201/document-types`,
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api getDocumentTypes error')
            throw error
        }
    },
    async getPreSignedUrl(data, pageKey) {
        try{            
            const response = await axios.post(`HR201/pre-signed-url`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api getDocumentTypes error')
            throw error
        }
    },
    async getUploads(userId, folderId, pageKey) {
        try{            
            const response = await axios.get(`HR201/${userId}/uploads/${folderId}`,
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api getDocumentTypes error')
            throw error
        }
    },
    async createFolder(data) {
        try{            
            const response = await axios.post(`HR201/folder`, {
                folder: data
            },
            {
                headers: {
                    'page_key': pageKeys.hr201
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api createFolder error')
            throw error
        }
    },
    async updateFolder(data) {
        try{            
            const response = await axios.patch(`HR201/folder`, {
                folder: data
            },
            {
                headers: {
                    'page_key': pageKeys.hr201
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api updateFolder error')
            throw error
        }
    },
    async deleteFile(data, pageKey) {
        try{            
            const response = await axios.post(`HR201/upload/delete-file`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api deleteFile error')
            throw error
        }
    },
    async delete201Record(data, pageKey) {
        try{            
            const response = await axios.post(`HR201/upload/delete`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api delete201Record error')
            throw error
        }
    },
    async saveUpload(data, pageKey) {
        try{            
            const response = await axios.post(`HR201/save-upload`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })            
            return response
        }catch (error){
            console.log('HR201 api saveUpload error')
            throw error
        }
    },
    async generateCOE(data, pageKey) {
        try {
            const response = await axios.post(`HR201/coe`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })
            return response;  
        }catch (error) {
            throw error
        }
    }   
}